<div class="page-content-wrapper">
  <app-sidebar-layout [showMenuToggle]="true">
    <div class="table-header">
      <div class="card-main-title">
        <app-tab-main [links]="tabs"></app-tab-main>
      </div>
      <div class="table-actions">
        <div class="search-input-div search-input-container">
          <div class="input-group">
            <button type="submit" class="input-group-addon">
              <label class="label-icon" for="search">
                <i class="material-icons mb-0">search</i>
              </label>
            </button>
            <div class="input-field">
              <input
                type="search"
                #searchInputField
                class="search-input mb-0"
                placeholder="{{ 'Search Lab' | translate }}"
                (input)="applyFilter(searchInputField.value)"
                />
              </div>
            </div>
          </div>

          <div class="add-entity">
            <div class="grid-button-container">
              <button
                type="button"
                class="btn"
                mat-button
                (click)="openLab()"
                >
                <span>{{ 'Add Lab' | translate }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <section class="card-style-sec p-20 row mx-0">
        @for (group of labGroups; track trackByIndex($index)) {
          <div
            class="lab-list col"
            >
            <span class="title">{{ group.title | translate }}</span>
            <ul>
              @for (lab of group.labs; track trackById($index, lab)) {
                <li
                  (click)="openLabIntegrationDetails(lab)"
                  >
                  {{ lab.labName }}
                </li>
              }
            </ul>
          </div>
        }
      </section>
    </app-sidebar-layout>
  </div>
